"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = require("styled-components");
exports.parseMetricToNum = function (fontAsString) { return parseFloat(fontAsString.replace(/[^0-9/.]/g, '')); };
exports.fontSize = function (size, lineHeight) { return styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n"], ["\n  font-size: ", ";\n  line-height: ",
    ";\n"])), function (props) { return (exports.parseMetricToNum(size) / exports.parseMetricToNum(props.theme.global.font.size)) * 1 + "rem"; }, function (props) {
    return lineHeight ||
        Math.ceil(exports.parseMetricToNum(size) / exports.parseMetricToNum(props.theme.global.lineHeight)) *
            (exports.parseMetricToNum(props.theme.global.lineHeight) / exports.parseMetricToNum(size)) + "px";
}); };
exports.addBreakpoint = function (breakpoint, content, direction) {
    var query;
    switch (direction) {
        case 'up':
            query = "(min-width: " + breakpoint.minValue + "px)";
            break;
        case 'down':
            query = typeof breakpoint.maxValue === 'number' ? "(max-width: " + breakpoint.maxValue + "px)" : "";
            break;
        case 'only':
            query = "(min-width: " + breakpoint.minValue + "px) " + (typeof breakpoint.maxValue === 'number' &&
                "and (max-width: " + breakpoint.maxValue + "px)");
            break;
        default:
            query = "(min-width: " + breakpoint.minValue + "px) " + (typeof breakpoint.maxValue === 'number' ? "and (max-width: " + breakpoint.maxValue + "px)" : "");
            break;
    }
    return query
        ? styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n        @media only screen and ", " {\n          ", "\n        }\n      "], ["\n        @media only screen and ", " {\n          ", "\n        }\n      "])), query, content) : styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject([""], [""])));
};
exports.findAllByType = function (component, type) {
    var matches = [];
    if (component.type === type) {
        matches.push(component);
    }
    if (component.children) {
        component.children.forEach(function (child) {
            matches = matches.concat(exports.findAllByType(child, type));
        });
    }
    return matches;
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=mixins.js.map